import { STACK } from './constants';
import * as Types from './types';

export const removeStackEntry = (stackEntry: Types.ISocketStackEntry) => {
    const index = STACK.findIndex((item) => item.timer === stackEntry.timer);

    if (index > -1) {
        STACK.splice(index, 1);
    }
};

export const addStackEntry = (stackEntry: Types.ISocketStackEntry) => {
    STACK.unshift(stackEntry);
};
